// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RatingModal-module--wrapper--3m7uc","innerWrapper":"RatingModal-module--innerWrapper--29LZH","line":"RatingModal-module--line--3Sb_A"};